export default __webpack_public_path__ + "static/media/light-chart.ef44893f.png";